// extracted by mini-css-extract-plugin
export default {"switcher":"switcher_switcher__mS8Jx","slider":"switcher_slider__kbaM5","round":"switcher_round__AOZMq"};